/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List, Popup,
  Button, Icon, Dimmer, Loader, Table
} from "semantic-ui-react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ApexCharts from "apexcharts";
import ProblemCard from "./ProblemCard";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import TsExpertReport from "./TsExpertReport";
import Utils from "../utilities/Utils";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

const UtilsInstance = new Utils();

let dpWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    type: "line",
  },
  colors: [Constants.PURPLE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -8,
    max: 8,
    tickAmount: 16,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + " V";
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      networkTag: "",
      uptime: "",
      startTime: "",
      problems: [],
      groupedProblems: {
        "terminationOFF": [],
        "noPowerSupplyTermination": [],
        "highResistance": [],
        "aNotOk": [],
        "bNotOk": [],
        "longCable": [],
        "noise": [],
        "reflection": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": [],
      },
      currentProblemType: "",
      currentProblemList: [],
      // The report
      report: "",
      equipmentIp: "",
      isGenerateReportDimmerActive: false,
      isFiveChannelsScope: sessionStorage.getItem("fiveChannels") === "true"
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch(() => {
          return [];
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      problems: [...resolvedPromisses[0], ...resolvedPromisses[2]],
      startTime: resolvedPromisses[1],
    }, () => {
      this.checkProblemsListSize();
      this.groupProblemsByType();
    });
  }

  retrieveTagAndUptimeData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        networkTag: data.networkTag,
        uptime: this.formatToRelativeTime(data.uptime)
      }));
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => {
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  checkProblemsListSize = () => {
    if (this.state.problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      "terminationOFF": [],
      "noPowerSupplyTermination": [],
      "highResistance": [],
      "aNotOk": [],
      "bNotOk": [],
      "longCable": [],
      "noise": [],
      "reflection": [],
      "fiberLowerLimitMaintenanceRequired": [],
      "fiberLowerLimitUrgentMaintenance": [],
      "fiberSignalLost": [],
    };

    for (let i = 0; i < this.state.problems.length; i++) {
      if (this.state.problems[i].type === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
        newGroupedProblems.terminationOFF.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
        newGroupedProblems.noPowerSupplyTermination.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
        newGroupedProblems.highResistance.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.A_NOT_OK_PROBLEM_TYPE) {
        newGroupedProblems.aNotOk.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.B_NOT_OK_PROBLEM_TYPE) {
        newGroupedProblems.bNotOk.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.LONG_CABLE_PROBLEM_TYPE) {
        newGroupedProblems.longCable.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
        newGroupedProblems.noise.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.REFLECTION_PROBLEM_TYPE) {
        newGroupedProblems.reflection.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
        newGroupedProblems.fiberLowerLimitMaintenanceRequired.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
        newGroupedProblems.fiberLowerLimitUrgentMaintenance.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
        newGroupedProblems.fiberSignalLost.push(this.state.problems[i]);
      }
    }

    this.setState({ groupedProblems: newGroupedProblems });
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
          </List.Content>
          {this.getListContent(problemType)}
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    if (problemType === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.TERMINATION_OFF_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NO_POWER_SUPPLY_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.HIGH_RESISTANCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.A_NOT_OK_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.B_NOT_OK_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.LONG_CABLE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NOISE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.REFLECTION_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.REFLECTION_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    if (this.state.currentProblemType === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.TERMINATION_OFF_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.TERMINATION_OFF_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.TERMINATION_OFF_SUGGESTION_3}</li>
            <li>{Strings.TERMINATION_OFF_SUGGESTION_4}</li>
            <li>{Strings.TERMINATION_OFF_SUGGESTION_5}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.TERMINATION_OFF_SUGGESTION_6}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NO_POWER_SUPPLY_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.NO_POWER_SUPPLY_SUGGESTION_2}</p>
          <ul>
            <li>Pin 5 &#8805; GND </li>
            <li>Pin 6 &#8805; + 5Vdc</li>
          </ul>
          <p>{Strings.NO_POWER_SUPPLY_SUGGESTION_3}</p>
          <p>{Strings.NO_POWER_SUPPLY_SUGGESTION_4}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.HIGH_RESISTANCE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.HIGH_RESISTANCE_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.HIGH_RESISTANCE_SUGGESTION_3}</li>
            <li>{Strings.HIGH_RESISTANCE_SUGGESTION_4}</li>
            <li>{Strings.HIGH_RESISTANCE_SUGGESTION_5}</li>
            <li>{Strings.HIGH_RESISTANCE_SUGGESTION_6}</li>
            <li>{Strings.HIGH_RESISTANCE_SUGGESTION_7}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.HIGH_RESISTANCE_SUGGESTION_8}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.A_NOT_OK_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.A_NOT_OK_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.A_NOT_OK_SUGGESTION_3}</li>
            <li>{Strings.A_NOT_OK_SUGGESTION_4}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.B_NOT_OK_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.B_NOT_OK_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.B_NOT_OK_SUGGESTION_3}</li>
            <li>{Strings.B_NOT_OK_SUGGESTION_4}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.LONG_CABLE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.LONG_CABLE_SUGGESTION_2}</p>
          <p style={{ textAlign: "justify" }}>{Strings.LONG_CABLE_SUGGESTION_3}</p>
          <Table columns={2} celled textAlign="center" size="small">

            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{Strings.BAUD_RATE_}</Table.HeaderCell>
                <Table.HeaderCell>{Strings.LENGTH}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Row>
              <Table.Cell>{Strings.NINE_SIX_KBITS}</Table.Cell>
              <Table.Cell>1000 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.NINETEEN_KBITS}</Table.Cell>
              <Table.Cell>1000 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.FORTY_FIVE_KBITS}</Table.Cell>
              <Table.Cell>1000 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.NINETY_THREE_KBITS}</Table.Cell>
              <Table.Cell>1000 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.HUN_EIGHTY_SEVEN_KBITS}</Table.Cell>
              <Table.Cell>1000 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.FIVE_HUNDRED_KBITS}</Table.Cell>
              <Table.Cell>400 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.ONE_FIVE_KBITS}</Table.Cell>
              <Table.Cell>200 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.THREE_MBPS}</Table.Cell>
              <Table.Cell>100 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.SIX_MBPS}</Table.Cell>
              <Table.Cell>100 m</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>{Strings.TWELVE_MBPS}</Table.Cell>
              <Table.Cell>100 m</Table.Cell>
            </Table.Row>

          </Table>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NOISE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.NOISE_SUGGESTION_2}</p>
          <ul>
            <li>{Strings.NOISE_SUGGESTION_3}</li>
            <li>{Strings.NOISE_SUGGESTION_4}</li>
            <li>{Strings.NOISE_SUGGESTION_5}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.NOISE_SUGGESTION_6}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.REFLECTION_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.REFLECTION_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.REFLECTION_SUGGESTION_2}</p>
          <ul>
            <li>{Strings.REFLECTION_SUGGESTION_3}</li>
            <li>{Strings.REFLECTION_SUGGESTION_4}</li>
            <li>{Strings.REFLECTION_SUGGESTION_5}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.REFLECTION_SUGGESTION_6}</p>
          <p style={{ textAlign: "justify" }}>{Strings.REFLECTION_SUGGESTION_7}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3}</li>
            <li>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4}</li>
          </ul>
          <p style={{ textAlign: "justify" }}>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_2}</li>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_3}</li>
            <li>{Strings.FIBER_SIGNAL_LOSS_SUGGESTION_4}</li>
          </ul>
        </Segment>
      );
    }
  }

  getProblemCards = () => {
    return (
      <Segment>
        <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
        {
          this.state.currentProblemList.map(problem => (
            <ProblemCard
              key={problem._id}
              nowMillis={this.state.nowMillis}
              startTime={this.state.startTime}
              problem={problem} />
          ))
        }
      </Segment>
    );
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = async () => {
    this.setState({ report: "" }, async () => {
      this.setGeneratingDimmerState(true);

      let problemsWithWaves = await fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let problemsFiber = await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch(() => {
          return [];
        });

      let problems = [...problemsWithWaves, ...problemsFiber];

      let networkData = await fetch(Constants.REQUEST_IP_ADDRESS + "networkData", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let tag = await fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag);

      let uptime = await fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.uptime);

      let configData = await fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let wifiStatus = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.status);

      let wifiConfigData = "";

      if (wifiStatus === Constants.CONNECTED_STATUS) {
        wifiConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data);
      }
      else {
        wifiConfigData = {
          "wifiMode": "",
          "hiddenSSID": false,
          "wifiName": "",
          "wifiAddr": "",
          "wifiNetmask": "",
          "wifiGateway": "",
          "wifiDNS": "",
          "wifiPwd": ""
        };
      }

      let reportGroupedProblems = {
        "terminationOFF": [],
        "noPowerSupplyTermination": [],
        "highResistance": [],
        "aNotOk": [],
        "bNotOk": [],
        "longCable": [],
        "noise": [],
        "reflection": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
          reportGroupedProblems.terminationOFF.push(problems[i]);
        }
        else if (problems[i].type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
          reportGroupedProblems.noPowerSupplyTermination.push(problems[i]);
        }
        else if (problems[i].type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
          reportGroupedProblems.highResistance.push(problems[i]);
        }
        else if (problems[i].type === Constants.A_NOT_OK_PROBLEM_TYPE) {
          reportGroupedProblems.aNotOk.push(problems[i]);
        }
        else if (problems[i].type === Constants.B_NOT_OK_PROBLEM_TYPE) {
          reportGroupedProblems.bNotOk.push(problems[i]);
        }
        else if (problems[i].type === Constants.LONG_CABLE_PROBLEM_TYPE) {
          reportGroupedProblems.longCable.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
          reportGroupedProblems.noise.push(problems[i]);
        }
        else if (problems[i].type === Constants.REFLECTION_PROBLEM_TYPE) {
          reportGroupedProblems.reflection.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
          reportGroupedProblems.fiberLowerLimitMaintenanceRequired.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
          reportGroupedProblems.fiberLowerLimitUrgentMaintenance.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
          reportGroupedProblems.fiberSignalLost.push(problems[i]);
        }
      }

      let terminationOFFImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.terminationOFF);
      let noPowerSupplyTerminationImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.noPowerSupplyTermination);
      let highResistanceImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.highResistance);
      let aNotOkImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.aNotOk);
      let bNotOkImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.bNotOk);
      let longCableImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.longCable);
      let noiseImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.noise);
      let reflectionImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.reflection);

      this.setState({
        equipmentIp: configData.addr,
        report:
          <TsExpertReport
            nowMillis={this.state.nowMillis}
            startTime={this.state.startTime}
            terminationOFF={reportGroupedProblems.terminationOFF}
            terminationOFFImages={terminationOFFImages}
            noPowerSupplyTermination={reportGroupedProblems.noPowerSupplyTermination}
            noPowerSupplyTerminationImages={noPowerSupplyTerminationImages}
            highResistance={reportGroupedProblems.highResistance}
            highResistanceImages={highResistanceImages}
            aNotOk={reportGroupedProblems.aNotOk}
            aNotOkImages={aNotOkImages}
            bNotOk={reportGroupedProblems.bNotOk}
            bNotOkImages={bNotOkImages}
            longCable={reportGroupedProblems.longCable}
            longCableImages={longCableImages}
            noise={reportGroupedProblems.noise}
            noiseImages={noiseImages}
            reflection={reportGroupedProblems.reflection}
            reflectionImages={reflectionImages}
            fiberLowerLimitMaintenanceRequired={reportGroupedProblems.fiberLowerLimitMaintenanceRequired}
            fiberLowerLimitUrgentMaintenance={reportGroupedProblems.fiberLowerLimitUrgentMaintenance}
            fiberSignalLost={reportGroupedProblems.fiberSignalLost}
            baudRate={networkData.baudrate}
            masters={networkData.nMasters}
            slaves={networkData.nSlaves}
            tensaoIdle={networkData.tensaoIdle}
            tag={tag}
            uptime={uptime}
            configData={configData}
            wifiConfigData={wifiConfigData}
            isFiveChannelsScope={this.state.isFiveChannelsScope}
          />
      });
    });
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  getOscilloscopeImgURIs = async (groupedProblem) => {
    let imgURIs = [];

    // Only try to generate the images if the array is not empty
    if (groupedProblem.length > 0) {
      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), dpWaveFormOptions);
      chart.render();

      for (let i = 0; i < groupedProblem.length; i++) {
        let imgURIObj = {
          "_id": groupedProblem[i]._id,
          "address": groupedProblem[i].address,
          "waveBA": "",
          "waveAB": "",
          "ntp": groupedProblem[i].ntp,
          "time": groupedProblem[i].time
        };

        if (this.state.isFiveChannelsScope) {
          imgURIObj["channel"] = groupedProblem[i].channel;
        }

        let options = {};

        if (groupedProblem[i].type === Constants.TERMINATION_OFF_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.LONG_CABLE_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.REFLECTION_PROBLEM_TYPE) {
          // First render the wave B - A to get its imgURI
          options = this.getFormatedDPOptions(groupedProblem[i].wave, dpWaveFormOptions);

          options = {
            ...options,
            colors: [Constants.PURPLE_HEX],
            title: {
              text: Strings.B_A,
            },
            series: [
              { name: Strings.WAVE_B_A, data: this.formatDPWaveTimes(groupedProblem[i].wave) }
            ]
          };

          chart.updateOptions(options, false, false, false);

          imgURIObj.waveBA = await chart.dataURI();
        }

        if (groupedProblem[i].type === Constants.A_NOT_OK_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.B_NOT_OK_PROBLEM_TYPE
          || groupedProblem[i].type === Constants.NOISE_PROBLEM_TYPE) {
          // Now render the A and B waves and get their imgURIs
          options = this.getFormatedDPOptions(groupedProblem[i].waveA, dpWaveFormOptions);

          options = {
            ...options,
            colors: [Constants.GREEN_HEX, Constants.RED_HEX],
            title: {
              text: Strings.A_AND_B,
            },
            series: [
              { name: Strings.WAVE_A, data: this.formatDPWaveTimes(groupedProblem[i].waveA) },
              { name: Strings.WAVE_B, data: this.formatDPWaveTimes(groupedProblem[i].waveB) }
            ]
          };

          chart.updateOptions(options, false, false, false);

          imgURIObj.waveAB = await chart.dataURI();
        }

        // Save both waves URIs
        imgURIs.push(imgURIObj);
      }

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIs;
    }
    else {
      return imgURIs;
    }
  }

  getFormatedDPOptions = (wave, dpOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatDPWaveTimes = (wave) => {
    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds 
      // (it already is by default, so do nothing here)
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 3);
      }
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 6);
      }
    }

    return wave;
  }

  // ------ TS Expert Modal ------

  retrieveData2 = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpert", { mode: "cors" })
        .then(UtilsInstance.checkStatus)  
        .then(res => res.json())
        .then(data => data)
        .catch(() => {
          return [];
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);
    let problems = [...resolvedPromisses[0], ...resolvedPromisses[2]];
    let startTime = resolvedPromisses[1];

    if (problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = {
        "terminationOFF": [],
        "noPowerSupplyTermination": [],
        "highResistance": [],
        "aNotOk": [],
        "bNotOk": [],
        "longCable": [],
        "noise": [],
        "reflection": [],
        "fiberLowerLimitMaintenanceRequired": [],
        "fiberLowerLimitUrgentMaintenance": [],
        "fiberSignalLost": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
          newGroupedProblems.terminationOFF.push(problems[i]);
        }
        else if (problems[i].type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
          newGroupedProblems.noPowerSupplyTermination.push(problems[i]);
        }
        else if (problems[i].type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
          newGroupedProblems.highResistance.push(problems[i]);
        }
        else if (problems[i].type === Constants.A_NOT_OK_PROBLEM_TYPE) {
          newGroupedProblems.aNotOk.push(problems[i]);
        }
        else if (problems[i].type === Constants.B_NOT_OK_PROBLEM_TYPE) {
          newGroupedProblems.bNotOk.push(problems[i]);
        }
        else if (problems[i].type === Constants.LONG_CABLE_PROBLEM_TYPE) {
          newGroupedProblems.longCable.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOISE_PROBLEM_TYPE) {
          newGroupedProblems.noise.push(problems[i]);
        }
        else if (problems[i].type === Constants.REFLECTION_PROBLEM_TYPE) {
          newGroupedProblems.reflection.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
          newGroupedProblems.fiberLowerLimitMaintenanceRequired.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
          newGroupedProblems.fiberLowerLimitUrgentMaintenance.push(problems[i]);
        }
        else if (problems[i].type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
          newGroupedProblems.fiberSignalLost.push(problems[i]);
        }
      }

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
          startTime: startTime
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
          startTime: startTime,
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          "terminationOFF": [],
          "noPowerSupplyTermination": [],
          "highResistance": [],
          "aNotOk": [],
          "bNotOk": [],
          "longCable": [],
          "noise": [],
          "reflection": [],
          "fiberLowerLimitMaintenanceRequired": [],
          "fiberLowerLimitUrgentMaintenance": [],
          "fiberSignalLost": [],
        },
        currentProblemType: "",
        currentProblemList: [],
        startTime: startTime,
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  getCurrentProblemsList = (groupedProblems) => {
    if (this.state.currentProblemType === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return groupedProblems.terminationOFF;
    }
    else if (this.state.currentProblemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return groupedProblems.noPowerSupplyTermination;
    }
    else if (this.state.currentProblemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return groupedProblems.highResistance;
    }
    else if (this.state.currentProblemType === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return groupedProblems.aNotOk;
    }
    else if (this.state.currentProblemType === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return groupedProblems.bNotOk;
    }
    else if (this.state.currentProblemType === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return groupedProblems.longCable;
    }
    else if (this.state.currentProblemType === Constants.NOISE_PROBLEM_TYPE) {
      return groupedProblems.noise;
    }
    else if (this.state.currentProblemType === Constants.REFLECTION_PROBLEM_TYPE) {
      return groupedProblems.reflection;
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return groupedProblems.fiberLowerLimitMaintenanceRequired;
    }
    else if (this.state.currentProblemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return groupedProblems.fiberLowerLimitUrgentMaintenance;
    }
    else if (this.state.currentProblemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return groupedProblems.fiberSignalLost;
    }
    else {
      return [];
    }
  }

  checkProblem = async (problem) => {
    this.solveProblem(problem, false);
  }

  solveProblem = (problem, forceSolve) => {
    if (problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE ||
      problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE ||
      problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE
    ) {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/solveProblem_POST", {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          problem: problem,
          forceSolve: false
        })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem._id).style.display = "none";
          this.retrieveData2();
        })
        .catch((error) => {
          alert(Strings.PROBLEM_CHECK_ERROR + Strings.REASON + error);
          this.props.onProblemSolve(false, {});
        });
    } else {
      fetch(Constants.REQUEST_IP_ADDRESS + "solveProblem_POST", {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          problem: problem,
          forceSolve: forceSolve
        })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem._id).style.display = "none";
          this.retrieveData2();
        })
        .catch((error) => {
          alert(Strings.PROBLEM_CHECK_ERROR + Strings.REASON + error);
          this.props.onProblemSolve(false, {});
        });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveTagAndUptimeData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveTagAndUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.checkProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    return (
      <div>

        <Grid style={gridStyle} columns={3} doubling>

          <Grid.Column verticalAlign="middle" style={{ paddingBottom: "0" }}>

            <Header as='h2' style={networkTagStyle}>
              <Popup position='bottom left' hoverable pinned wide="very"
                trigger={
                  <Icon name="question circle" size="small" color="teal" />
                }>
                <Popup.Content>
                  <p>{Strings.TS_EXPERT_POPUP_1}</p>
                  <p>{Strings.TS_EXPERT_POPUP_2}</p>
                  <p>{Strings.TS_EXPERT_POPUP_3}</p>
                  <p><b>{Strings.SEARCH_POPUP_6_1}</b>{Strings.TS_EXPERT_POPUP_4}</p>
                </Popup.Content>
              </Popup >
              {this.state.networkTag}
            </Header>

          </Grid.Column>

          <Grid.Column verticalAlign="middle" textAlign="center" style={{ paddingBottom: "0" }}>
            <Button
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />

            <Dimmer page active={this.state.isGenerateReportDimmerActive} >
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

            <PDFDownloadLink
              className="download-link"
              style={pdfLinkStyle}
              document={this.state.report}
              fileName={
                `${Strings.ACTIONS_LIST_FILENAME_PART} (${this.state.equipmentIp}).pdf`
              }>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINISHING;
                }
                else {
                  if (this.state.isGenerateReportDimmerActive) {
                    let downloadLink = document.getElementsByClassName("download-link")[0];
                    downloadLink.onclick = () => {
                      setTimeout(() => {
                        if (downloadLink !== null && downloadLink !== undefined) {
                          downloadLink.innerHTML = "";
                        }
                      }, 1500);
                    };
                    this.setGeneratingDimmerState(false);
                  }
                  return Strings.SAVE_ACTIONS_LIST;
                }
              }}
            </PDFDownloadLink>
          </Grid.Column>

          <Grid.Column style={{ paddingBottom: "0" }}>
            <Segment style={floatStyle} size="large" compact textAlign="center">
              <Icon color="green" name="arrow alternate circle up" />
              {Strings.TIME_ON} {this.state.uptime}
            </Segment>
          </Grid.Column>

        </Grid>

        <Grid style={gridStyle} columns={2} doubling>

          <Grid.Column>
            <Segment style={leftSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.EVENTS_LIST}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.TERMINATION_OFF_PROBLEM_TYPE, this.state.groupedProblems.terminationOFF)}
                  {this.getListItem(Constants.NO_POWER_SUPPLY_PROBLEM_TYPE, this.state.groupedProblems.noPowerSupplyTermination)}
                  {this.getListItem(Constants.HIGH_RESISTANCE_PROBLEM_TYPE, this.state.groupedProblems.highResistance)}
                  {this.getListItem(Constants.A_NOT_OK_PROBLEM_TYPE, this.state.groupedProblems.aNotOk)}
                  {this.getListItem(Constants.B_NOT_OK_PROBLEM_TYPE, this.state.groupedProblems.bNotOk)}
                  {this.getListItem(Constants.LONG_CABLE_PROBLEM_TYPE, this.state.groupedProblems.longCable)}
                  {this.getListItem(Constants.NOISE_PROBLEM_TYPE, this.state.groupedProblems.noise)}
                  {this.getListItem(Constants.REFLECTION_PROBLEM_TYPE, this.state.groupedProblems.reflection)}
                  {this.getListItem(Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE, this.state.groupedProblems.fiberLowerLimitMaintenanceRequired)}
                  {this.getListItem(Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE, this.state.groupedProblems.fiberLowerLimitUrgentMaintenance)}
                  {this.getListItem(Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE, this.state.groupedProblems.fiberSignalLost)}
                </List>
              </Segment>

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-problem-detected-header"
                as='h2'
                icon
                color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader>
                  <p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p>
                </Header.Subheader>
              </Header>

            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment style={rightSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.ACTIONS}
              </Header>
              <Divider clearing />

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-task-selected-header"
                as="h2"
                icon
                color="teal">
                <Icon name='edit outline' color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>
                  {Strings.CHOOSE_AN_EVENT}
                </Header.Subheader>
              </Header>

              <Segment id="task-details" style={taskSegmentStyle}>

                <Button
                  size="tiny"
                  circular
                  icon="times"
                  onClick={this.handleCloseButtonClick} />

                {this.getActions()}
                {this.getProblemCards()}

              </Segment>

            </Segment>

          </Grid.Column>

        </Grid>

        <div style={lastUpdateContainerStyle}>
          <div>
            <p>
              <b>{Strings.LAST_UPDATED}</b>
              {this.state.lastUpdate.toLocaleString("pt-BR")}
              {Strings.THIS_COMPUTER_TIME}
            </p>
          </div>
          <div>
            <Button
              style={{ marginLeft: "8px" }}
              circular
              color="teal"
              icon="refresh"
              onClick={this.retrieveData2} />
          </div>
        </div>

        <div id="chart" style={chartsStyle}></div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "66vh"
};

const rightSegmentStyle = {
  height: "66vh"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "14vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const pdfLinkStyle = {
  marginLeft: "8px"
};

const networkTagStyle = {
  color: "#576577"
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

const chartsStyle = {
  width: "1026px",
  height: "580px",
  display: "none",
  visibility: "hidden"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
